import React, { useState } from 'react';
import { Box } from '@mui/material';
import Hero from './components/Hero';
import AdvancedPlatform from './components/AdvancedPlatform';
import KeyFeatures from './components/KeyFeatures';
// import Reviews from './components/Reviews';
import Footer from './components/Footer';
import Header from './components/Header';
import ContactUs from './components/ContactUs';
import PlayVideo from './components/PlayVideo';

function App() {
  const [isContactUsOpened, setContactUsOpened] = useState(false);
  const [isVideoOpened, setVideoOpened] = useState(false);

  return (
    <Box>
      <Header setContactUsOpened={setContactUsOpened} />
      <Hero setContactUsOpened={setContactUsOpened} setVideoOpened={setVideoOpened} />
      <AdvancedPlatform setContactUsOpened={setContactUsOpened} />
      <KeyFeatures setVideoOpened={setVideoOpened} />
      {/* <Reviews /> */}
      <Footer setContactUsOpened={setContactUsOpened} />

      <ContactUs isContactUsOpened={isContactUsOpened} setContactUsOpened={setContactUsOpened} />
      <PlayVideo isOpened={isVideoOpened} setOpened={setVideoOpened} />
    </Box>
  );
}

export default App;
